import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

// Role IDs that can access admin-only pages (excludes Moderator)
const ADMIN_ONLY_ROLE_IDS = ["1502218902770548796", "1499913787833319566", "1499913527752655028"];

/**
 * Returns { allowed: bool | null }
 * null  = still checking
 * true  = user has an admin role
 * false = denied
 */
export default function useAdminOnly() {
  const { session } = useAuth();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    if (session === undefined) return; // still resolving
    if (!session) { setAllowed(false); return; }

    const discordId =
      session.user?.identities?.find(i => i.provider === "discord")?.id ||
      session.user?.user_metadata?.provider_id;

    if (!discordId) { setAllowed(false); return; }

    fetch("/api/check-staff-role", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        discord_id: discordId,
        secret: process.env.REACT_APP_DM_WEBHOOK_SECRET,
        role_ids: ADMIN_ONLY_ROLE_IDS,
      }),
    })
      .then(r => r.json())
      .then(data => setAllowed(!!data.hasRole))
      .catch(() => setAllowed(false));
  }, [session]);

  return { allowed };
}
